export enum IntervalPrice {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
}

export interface ProductSubscription {
  id: string;
  title: string;
  description: string;
  recommended: boolean;
  features: string[];
  pricing: {
    [key in IntervalPrice]: PriceSubscription;
  };
}

export interface PriceSubscription {
  id: string;
  price: number;
  interval: string;
  intervalCount: number;
  trial?: number;
}
